import AuthKit from "./AuthKit";
import eventStatus from "./enums/eventStatus";

export default class {
  constructor() {
    this.authKit = new AuthKit();
    this.url = "/events/";
  }

  async getEventList() {
    const url = `${this.url}events/`;
    const response = await this.authKit.doGet(url);
    return response.data;
  }

  async getEventDetail(eventSlug) {
    const uri = `${this.url}events/${eventSlug}/`;
    const url = this.authKit.createBaseAPIUrl(uri);
    const response = await fetch(url);
    if (response.status === 404) return null;
    return await response.json();
  }

  async getEventUserList(eventSlug, searchTerm = "", filterData = {}) {
    let url = `${this.url}event-users/${eventSlug}/`;
    const params = { answers: JSON.stringify(filterData), search: searchTerm };
    const filterURL = new URLSearchParams(params).toString();
    url = `${url}?${filterURL}`;
    const response = await this.authKit.doGet(url);
    return response.data;
  }

  async getEventUserListLoadMore(nextUrl) {
    const response = await this.authKit.doGet(nextUrl);
    return response.data;
  }

  async getEventUserMe(eventSlug, tokenOverride) {
    let url = `${this.url}event-users/${eventSlug}/me/`;
    const response = await this.authKit.doGet(url, {}, tokenOverride);
    return response.data;
  }

  async updateEventUserMe(eventSlug, payload, tokenOverride, useProxy=false) {
    let url = `${this.url}event-users/${eventSlug}/me/`;
    const response = await this.authKit.doPatch(url, payload, tokenOverride, useProxy);
    return response.data;
  }

  async getEventQuestions(eventSlug) {
    const uri = `${this.url}events/${eventSlug}/questions/`;
    const url = this.authKit.createBaseAPIUrl(uri);
    const response = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return await response.json();
  }

  async registerUser(email, eventSlug) {
    const uri = `${this.url}events/${eventSlug}/register/`;
    const url = this.authKit.createBaseAPIUrl(uri);
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });
    return await response.json();
  }

  async oktaUserRegister(eventSlug, payload) {
    const uri = `${this.url}events/${eventSlug}/okta-register/`;
    const url = this.authKit.createBaseAPIUrl(uri);
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload)
    });
    return await response.json();
  }

  async checkInUser(eventSlug, uuid) {
    const uri = `${this.url}events/${eventSlug}/check-in/`;
    const url = this.authKit.createBaseAPIUrl(uri);
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ uuid }),
    });
    return await response.json();
  }

  shouldRender(eventData, me) {
    switch (eventData?.status) {
      case eventStatus.IDLE:
      case eventStatus.DRAFT:
        if(me) {
          return me?.canAccessIdleEvents ? true : false;
        }
        else {
          return false
        }
      case eventStatus.ACTIVE:
        return true;
    }
  }

  async twoFactorAuth(eventSlug, email, token) {
    const uri = `${this.url}events/${eventSlug}/two-factor-auth/`
    const url = this.authKit.createBaseAPIUrl(uri)
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, token }),
    })
    return await response.json();
  
  }
  async resendOTPToken(eventSlug, email) {
    const uri = `${this.url}events/${eventSlug}/resend-otp-token/`
    const url = this.authKit.createBaseAPIUrl(uri)
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    })
    return await response.json();
  }
}
